<div>
  <ngx-spinner size="medium" color="#fff" [type]="typeSelected" [fullScreen]="true"> </ngx-spinner>
</div>
<div class="loginPage">
  <div class="logo">
    <div class="container">
      <div class="row">
        <div class="col-12 col-sm-6">
          <div class="logo-main">
            <div class="ourlogo">
              <img src="/assets/images/Piqet_NewLogo.png" alt="Logo" />
            </div>
            <div class="rightside-text">
              <div class="logo1">
                Powering your <br />
                sustainability journey
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <form [formGroup]="loginForm">
    <div class="content">
      <div class="container">
        <ng-container
          *ngrxLet="{
            forgotPassword: (authFacade.forgotPassword$ | async),
            isForgotPassword: (authFacade.isForgotPassword$ | async)
          } as forgotPasswordData"
        >
          <div
            [ngClass]="
              forgotPasswordData.forgotPassword.messageType === 0 ? 'text-success' : 'input-error'
            "
            *ngIf="forgotPasswordData.isForgotPassword"
          >
            {{ forgotPasswordData.forgotPassword.message }}
          </div>
        </ng-container>
        <ng-container *ngrxLet="authFacade.isShowOtpPage$ as isShowOtpPage">
          <div *ngIf="!isShowOtpPage">
            <span class="form-title">Log in to PIQET</span>
            <ng-container *ngrxLet="authFacade.loginError$ as loginError">
              <div class="input-error invalidError" [innerHTML]="loginError"></div>
            </ng-container>
            <ng-container *ngIf="!isSSOLogin; else loginWithAzure">
              <!-- Email Field -->
              <div class="form-group required">
                <piqet-angular-common-input
                  formControlName="username"
                  [control]="loginForm.get('username')"
                  label="Email"
                  placeholder="name@company.com"
                  [maxLength]="150"
                  [inputType]="'text'"
                  [submitted]="submitted"
                  [errorMessages]="{
                    required: 'The email field is required.',
                    email: 'The email field is not a valid e-mail address.'
                  }"
                >
                </piqet-angular-common-input>
              </div>

              <!-- Password Field -->
              <div class="form-group required">
                <piqet-angular-common-input
                  formControlName="password"
                  [control]="loginForm.get('password')"
                  label="Password"
                  placeholder="Password"
                  [maxLength]="50"
                  [inputType]="'password'"
                  [showPasswordToggle]="true"
                  [submitted]="submitted"
                  [errorMessages]="{
                    required: 'The password field is required.',
                    pattern:
                      'Password must contain at least one numeric digit and alphabets only. First and Last character cannot be digit.'
                  }"
                >
                </piqet-angular-common-input>
              </div>

              <div class="form-actions box">
                <button type="submit" class="modelBtn purpleBtnHoverEffect" (click)="submit()">
                  Log in
                </button>
              </div>
            </ng-container>
            <ng-template #loginWithAzure>
              <div class="form-actions">
                <label></label>
                <button
                  type="submit"
                  id="loginWuthAzureBtn"
                  class="modelBtn purpleBtnHoverEffect"
                  (click)="submit('loginWithAzure')"
                >
                  Login With Azure
                </button>
              </div>
            </ng-template>
            <div class="forget-password text-center">
              <span>
                <a class="linkText" routerLink="/forgot-password">Forgot password?</a>
              </span>
              <span>
                <a class="linkText" (click)="onLoginIssue()">Can't log in?</a>
              </span>
              <span><a class="linkText" routerLink="/register">Signup</a></span>
            </div>
          </div>
          <div *ngIf="isShowOtpPage">
            <piqet-angular-verify-otp
              [userEmail]="loginForm.get('username')?.value"
              (verifyOtp)="verifyOtpMethod($event)"
            ></piqet-angular-verify-otp>
          </div>
        </ng-container>
        <div class="other-queries text-center">
          <a
            href="https://piqet.com/contact-us/"
            style="text-decoration: none; font-size: 14px"
            class="linkText"
            target="_blank"
            >Contact PIQET on licence or other queries</a
          >
        </div>
      </div>
    </div>
  </form>
  <div class="copyright">
    <a href="https://www.lifecycles.com.au/" target="_blank" class="linkText"
      >© Life Cycle Strategies Pty Ltd</a
    >
  </div>
</div>
